<template>
  <div class="resetpwd_wrap">
    <baseHeader :title="$t('修改密码')"></baseHeader>
    <form class="form" @submit.prevent="submit">
      <div class="item">
        <span class="icon">
          <img src="../images/login/phone_a.png" alt="" />
        </span>
        <input type="text" class="inp" v-model.trim="data.mobile" :placeholder="$t('请输入手机号码或邮箱')" />
      </div>
      <div class="item mt">
        <input type="text" class="inp" v-model.trim="data.code" :placeholder="$t('短信验证码')" />
        <van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
          <span @click="sendcode">{{
            showTime > 0 ? showTime : $t("发送")
          }}</span>
        </van-count-down>
      </div>
      <div class="item mt">
        <input type="password" class="inp" v-model.trim="data.password" :placeholder="$t('新密码')" />
      </div>
      <button type="submit" class="btn basic_btn">
        {{ $t("修改密码") }}
      </button>
    </form>
    <ft></ft>
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox } from "vant";
import Fetch from "../../utils/fetch";
import baseHeader from "@/components/baseHeader";
import ft from "../../components/ft.vue"
Vue.use(CountDown).use(Checkbox);

export default {
  name: "register",
  data() {
    return {
      showTime: 0,
      timeId: null,
      time: 0,
      data: {
        mobile: "",
        code: "",
        password: "",
      },
      is_send: false,
    };
  },
  components: {
    baseHeader,
    ft: ft
  },
  created() {
    this.$parent.footer("user", false);
  },
  mounted() {
    this.data.mobile = this.$route.query.phone;
    Fetch("/sms/getRecentCode", { event: "resetpwd" }).then((res) => {
      //console.log(res);
      if (res.data) {
        if (res.data) {
          this.data.mobile = res.data.mobile;
          this.loading_flag = false;
          this.is_send = true;
          let leftTime = 120 - (Date.parse(new Date()) / 1000 - res.data.createtime);
          //console.log(Date.parse(new Date()) / 1000, res.data.createtime);
          //console.log(leftTime);
          this.time = leftTime * 1000;
          this.showTime = leftTime;
          this.timeId = setInterval(() => {
            this.showTime--;
          }, 1000);
        }
      }
    });
  },
  destroyed() {
    if (this.timeId) clearInterval(this.timeId);
  },
  methods: {
    timeCall() {
      this.is_send = false;
      this.time = 0;
      clearInterval(this.timeId);
     // console.log("coundown finished");
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (!this.data.mobile) {
        this.$toast({
          type: "fail",
          background: "#07c160",
          message: this.$t("手机号码不能为空"),
          duration: 10000,
        });
        return false;
      }

      this.is_send = true;

      Fetch("/sms/send", {
        mobile: this.data.mobile,
        event: 'resetpwd',
      })
        .then(() => {
          this.time = 120 * 1000;
          this.showTime = 120;
          this.timeId = setInterval(() => {
            this.showTime--;
          }, 1000);
          this.$toast({
            background: "#07c160",
            message: this.$t("发送成功"),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {

      if (!this.data.mobile) {
        this.$toast({
          type: "fail",
          background: "#07c160",
          message: this.$t("手机号码不能为空"),
          duration: 10000,
        });
        return false;
      }




      if (!this.data.password) {
        this.$toast({
          type: "fail",
          background: "#07c160",
          message: this.$t("密码长度为6-18位"),
          duration: 3000,
        });
        return false;
      }

      if (this.data.password.length < 6) {
        this.$toast({
          type: "fail",
          background: "#07c160",
          message: this.$t("密码长度为6-18位"),
          duration: 3000,
        });
        return false;
      }

      if (!this.data.code) {
        this.$toast(this.$t("短信验证码不能为空"));
        return;
      }

      Fetch("/user/resetpwd", {
        mobile: this.data.mobile,
        newpassword: this.data.password,
        sms: this.data.code,
      }).then((res) => {
        if (res.code == 1) {
          this.$toast({
            background: "#07c160",
            message: this.$t("修改成功"),
          });
          setTimeout(() => {
            this.$router.push("/login")
          }, 3000);
        } else {
          this.$toast({
            type: "fail",
            background: "#07c160",
            message: res.msg,
            duration: 3000,
          });
        }

      });
      return;

    },
  },
};
</script>

<style lang="less" scoped>
.mt {
  margin-top: 20px;
}

/deep/ .base-header {
  background: none;
}
#app{
  height: 100%;
  position: relative;
}
.red_top_bg {
  background: none !important;
}

.back_left {
  background: url(../../views/images/item/back.png) no-repeat center center;
  background-size: 60% 60%;
}

.big_tit {
  color: #fff;
}

.resetpwd_wrap {
  position: absolute;
  width: 100%;
  background: url("../images/vip/vip.png") no-repeat;
  height: 100%;
  background-size: cover;
  padding-top: 44px;

}

.resetpwd_wrap .form {
  display: block;
  width: 96%;
  margin: 0 auto;
  padding-top: 28px;

}

.resetpwd_wrap .form .item {
  height: 30px;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 8px;
  box-sizing: content-box;
  //border: 1px solid red;
  background: #100e20;
  border-radius: 8px;

  .icon {
    width: 28px;
    height: 25px;

    img {
      display: block;
      margin: 0 auto;
      width: 17px;
      height: 20px;
    }
  }
}

.resetpwd_wrap .form .item .inp {
  height: 25px;
  margin-left: 7px;
  flex: 1;
  margin-bottom: 3px;
  color: #bebebe;
  //font-weight: 700;
  font-size: 0.4rem;
}

.get_captcha {
  flex: 1;
  margin-left: 10px;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
  height: 30px;
  background: url("../images/login/submit.png") no-repeat;
  background-size: cover;
  color: #073F22;
  font-weight: 700;
  border-radius: 8px;
}

.resetpwd_wrap .form .basic_btn {
  display: block;
  // background: linear-gradient(#fbe4cb, #e7bb90);
  color: #fff;
  font-weight: 700;
  margin: 15px auto;
  background: url("../images/login/submit.png") no-repeat;
  background-size: cover;
  color: #073F22;
}
</style>